<template>
  <GlobalWindow
    :visible.sync="visible"
    :confirm-working="isWorking"
    width="100%"
    title="分配打印模板"
    @confirm="confirm"
  >
    <p class="tip" v-if="departmentParams != null">
      为部门 <em>{{ departmentParams.name }}</em> 配置打印模板
    </p>
    <div class="printTemplate">
      <el-transfer
        v-model="selectedIds"
        :titles="['未分配普通模板', '已分配普通模板']"
        :props="{
          key: 'printTemplateId',
          label: 'printTemplateName',
        }"
        :data="printTemplateList"
      >
      </el-transfer>
      <el-transfer
        v-model="selectedIdsTwo"
        :titles="['未分配佳博模板', '已分配佳博模板']"
        :props="{
          key: 'printTemplateId',
          label: 'printTemplateName',
        }"
        :data="printTemplateListTwo"
      >
      </el-transfer>
    </div>
  </GlobalWindow>
</template>

<script>
import BasePage from "@/components/base/BasePage";
import GlobalWindow from "@/components/common/GlobalWindow";
import {
  findDeptPrintTemplateApi,
  saveTemplateApi,
  findAllTemplateApi,
} from "@/api/system/department";
export default {
  name: "PrintTemplateWindow",
  extends: BasePage,
  components: { GlobalWindow },
  data() {
    return {
      visible: false,
      isWorking: false,
      // 用户
      departmentParams: null,
      // 打印模板列表
      printTemplateList: null,
      printTemplateListTwo: null,
      // 已选中的德佟模板
      selectedIds: [],
      // 已选中的佳博模板
      selectedIdsTwo: [],
    };
  },
  methods: {
    /**
     * 打开窗口
     *
     * @param departmentParams 目标用户
     */
    open(departmentParams) {
      findAllTemplateApi().then((res) => {
        this.printTemplateList = res.commonTemlateList;
        this.printTemplateListTwo = res.jaboTemlateList;
        this.departmentParams = departmentParams;
        findDeptPrintTemplateApi({ deptId: this.departmentParams.id })
          .then((records) => {
            this.selectedIds = records.commonTemlateList.map(
              (r) => r.printTemplateId
            );
            this.selectedIdsTwo = records.jaboTemlateList.map(
              (r) => r.printTemplateId
            );
            this.visible = true;
          })
          .catch((e) => {
            this.$tip.apiFailed(e);
          });
      });
    },
    /**
     * 确认选择角色
     */
    confirm() {
      if (this.isWorking) {
        return;
      }
      this.isWorking = true;
      let commonTemlateList = this.selectedIds.map((item) => {
        return this.printTemplateList.find(
          (itemTwo) => itemTwo.printTemplateId === item
        );
      });
      let jaboTemlateList = this.selectedIdsTwo.map((item) => {
        return this.printTemplateListTwo.find(
          (itemTwo) => itemTwo.printTemplateId === item
        );
      });
      saveTemplateApi({
        commonTemlateList,
        jaboTemlateList,
        deptId: this.departmentParams.id,
      })
        .then(() => {
          this.visible = false;
          this.$emit("success");
          setTimeout(() => {
            this.$dialog.attentionConfirm("打印模板分配成功").then(() => {});
          }, 300);
        })
        .catch((e) => {
          this.$tip.apiFailed(e);
        })
        .finally(() => {
          this.isWorking = false;
        });
    },
    // 关闭
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variables.scss";
// 角色配置
.global-window {
  .tip {
    em {
      font-style: normal;
      color: $primary-color;
      font-weight: bold;
    }
  }
}
.printTemplate {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
/deep/ .el-transfer-panel {
  width: 400px;
}
/deep/ .el-transfer-panel__body {
  height: 400px;
}

/deep/ .el-transfer-panel__list {
  height: 400px;
}
</style>
